<div class="mouse-pointer" [ngStyle]="circleStyle">
  <div class="pointer-tip"></div>
</div>
